import { render } from "./WCAddToOrderTypeCartToast.vue?vue&type=template&id=0090cdac"
import script from "./WCAddToOrderTypeCartToast.vue?vue&type=script&lang=js"
export * from "./WCAddToOrderTypeCartToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__